<template>
  <div class="w-full flex p-3 justify-center">
    <div class="w-full">
      <div
        class="vx-row m-0 w-full text-left flex font-bold border-b border-gray-300"
      >
        <div class="vx-col p-2 flex-1 basis-1/12">Nº da Proposta</div>
        <div class="vx-col p-2 flex-1 basis-1/12">Data da Proposta</div>
        <div class="vx-col p-2 flex-1 basis-1/12">Tipo de cotação</div>
        <div class="vx-col p-2 flex-1 basis-2/12">Segurado</div>
        <div class="vx-col p-2 flex-1 basis-2/12">Veículo</div>
        <div class="vx-col p-2 flex-1 basis-1/12">
          Data de Envio da Vistoria
        </div>
        <div class="vx-col p-2 flex-1 basis-1/12">Corretora</div>
      </div>
      <ul>
        <li v-for="item in cotacoes" :key="item.id_proposta">
          <div
            class="vx-row m-0 w-full text-left flex border-b border-gray-200"
          >
            <div class="vx-col p-2 flex-1 basis-1/12 flex items-center">
              <a
                style="color: inherit"
                target="_blank"
                :href="getDetailsUrl(item)"
                class="cursor-pointer flex items-center justify-between w-6/12"
              >
                <div class="mr-2">
                  {{ item.proposal_number }}
                </div>
                <vs-icon
                  class="icon-spacing"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-external-link"
                ></vs-icon>
              </a>
            </div>
            <div class="vx-col p-2 flex-1 basis-1/12 flex items-center">
              {{ functions.formataDataHoraPadraoBR(item.proposal_date, false) }}
            </div>
            <div class="vx-col p-2 flex-1 basis-1/12 flex items-center">
              {{
                isEndorsement(item)
                  ? QUOTATION_TYPE.ENDORSEMENT
                  : QUOTATION_TYPE.NEW
              }}
            </div>
            <div class="vx-col p-2 flex-1 basis-4/12 flex items-center">
              <a
                target="_blank"
                style="color: inherit"
                :href="`/DetalheSegurado/${item.id_prospect}`"
                class="font-semibold flex items-center justify-between w-8/12"
              >
                {{ item.nome }}
                <vs-icon
                  class="icon-spacing"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-external-link"
                ></vs-icon>
              </a>
            </div>
            <div class="vx-col p-2 flex-1 basis-2/12 flex items-center">
              {{ item.placa && `${item.placa} - ` }} {{ item.veiculoModelo }}
            </div>
            <div class="vx-col p-2 flex-1 basis-1/12 flex items-center">
              {{ functions.formataDataHoraPadraoBR(item.dataVistoria, false) }}
            </div>
            <div class="vx-col p-2 flex-1 basis-1/12 flex items-center">
              {{ item.brokerName }}
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { QUOTATION_TYPE } from '../../../../constants/quotation.type';
import functions from '../../../../utils/functions';

export default {
  props: {
    cotacoes: Array,
  },
  data() {
    return {
      QUOTATION_TYPE,
      functions,
    };
  },
  methods: {
    isEndorsement(item) {
      return !!item.endorsementId;
    },
    getDetailsUrl(item) {
      return this.isEndorsement(item)
        ? `auto/apolice/${item.id_proposta}/endosso`
        : `/auto/proposta/${item.id_proposta}`;
    },
  },
};
</script>

<style scoped>
.vx-row {
  border-bottom: 1px solid #ddd;
}
.vx-col {
  box-sizing: border-box;
  padding: 8px;
}
.vs-button {
  margin-left: 5px;
}
</style>
